import { Button } from '@synoptic/ui-kit/button/button.js';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { clsx } from 'clsx';
import { PropsWithChildren } from 'react';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { brandContainer, mask, title } from '../_auth/brand.css.ts';
import { contentBlock } from '../_auth/page.css.ts';
import {
  enterpriseBrandContent,
  synopticLink,
} from './enterprise-brand.css.ts';

export const EnterpriseBrand = ({ children }: PropsWithChildren) => {
  const isTablet = useIsTablet();

  return (
    <div className={clsx(contentBlock, brandContainer)}>
      <div className={enterpriseBrandContent}>
        <div>
          <p className={title}>
            <span className={mask}>Enterprise</span> portal
          </p>
        </div>
        <div>
          <Button
            size={isTablet ? 'large' : 'small'}
            variant="outline"
            className={synopticLink}
            asChild
          >
            <Link to={paths.login}>Go to Synoptic</Link>
          </Button>
        </div>
      </div>
      {children}
    </div>
  );
};
